<template>
  <div>
    <span class="text__subtitle m-1">{{ $t("ticketActions.interesado.subtitle") }}</span>

    <SearchField
      v-bind="properties"/>

    <ExtendedSearch
      v-if="openModal && params.extraFilter"
      :filtersSearch="evalParam(params.extraFilter)"
      :filters="evalParam(params.filters)"
      :params="params"
      :title="label"
      @close="openModal = false"
      @send="getResultExtendedSearch($event)"
    >
    </ExtendedSearch>

    <div v-if="interesados.length > 0">
      <v-card class="card__container">
        <template>
          <v-chip
            v-for="(interesado, i) in interesados"
            :key="i"
            class="ma-2"
            :model-value="true"
          >
            {{ interesado.name }}
            <button
              @click.stop="deleteSuscripcion(interesado)"
            >
              <v-icon>mdi-delete</v-icon>
            </button>
          </v-chip>
        </template>
      </v-card>
    </div>
    <v-progress-circular
      v-if="loadingGetInteresados"
      class="primary--text"
      :style="{marginLeft: '2rem'}"
      indeterminate
    ></v-progress-circular>
    <p v-if="interesados.length === 10" class="text__interesado__help text__interesado__error">
      {{ $t("ticketActions.interesado.max") }}
    </p>
    <p v-if="loadingGetInteresados === false
      && interesados.length === 0"
      class="text__interesado__help">
      {{ $t("ticketActions.interesado.noBody") }}
    </p>

    <div class="d-flex flex-wrap justify-end">
      <v-btn
        class="mt-4"
        color="primary"
        right
        :block="!$vuetify.breakpoint.mdAndUp"
        dark
        @click="send"
        :loading="submitting"
      >
        {{ $t("commons.accept") }}
      </v-btn>

      <v-btn
        class="mt-4 ml-4"
        :block="!$vuetify.breakpoint.mdAndUp"
        right
        :disabled="submitting"
        @click="$emit('input')"
      >
        {{ $t("commons.cancel") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import SearchField from '../form/field-types/Search.vue';
// eslint-disable-next-line import/no-cycle
import { INTERESADOS } from './index';

export default {
  components: { SearchField },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    user: Object,
  },
  data() {
    return {
      submitting: false,
      loadingGetInteresados: false,
      openModal: false,
      isErrorDelete: false,
      isErrorCreate: false,
      comment: '',
      elementMax: 10,
      interesados: [],
      interesadosNew: [],
      interesadosDelete: [],
      alias: 'interesados',
      codigoInteresado: 400001,
      codigoSeguidor: 400002,
      params: {
        zalias: 'interesados',
        target: 'backend',
        entity: 'cnt',
        value: 'id',
        filters: '{"delete_flag":0,"type":{"$distinct":2308},"location.id":{"$not":["D67C447EFFF301FB9ABA001DD8C32A59","EC693C1C83B101F69C83001CC4BEAABC"]}}',
        match: 'middle_name,last_name,first_name,zdni',
        fields: 'id,first_name,middle_name,last_name,zdni,location.id,position.name,location.name,uspContact.gerhonteloc.id,uspContact.gerhonteloc.zonabasica,uspContact.gerhonteloc.ztipo_loc,gerhonteloc.site_id,zfecha_ini_contrato,zfecha_fin_contrato,ztelefono_preferente,uspContact.sgiCategoria.zcodigo,location.state,location.city',
        lookandfeel: '#item.middle_name::[$1 ]#item.last_name::[$1 ]#item.first_name::[$1 ]#item.location.name::[($1) ]',
        lookandfeelType: 'cnt',
        minlength: '8',
        extraFilter: '[{"text":"Nombre", "value": "middle_name"},{"text":"Apellido 1", "value": "last_name"},{"text":"Apellido 2", "value": "first_name"}, {"text":"Localización", "value": "location.name"}, {"text":"DNI", "value": "zdni", "display": false}, {"text":"Email", "value": "email_address"}]',
        timeSearch: '1500',
        placeholder: 'Puedes realizar una búsqueda más completa haciendo click en el icono del embudo',
        nodatamessage: 'No hay datos disponible. Puedes buscar por nombre y apellidos o DNI',
        isOrdenLocation: 'true',
      },
      properties: {
        zalias: 'interesados',
        label: 'Interesados',
        config: {
          hint: 'Puedes buscar por nombre y apellidos o DNI',
          component: 'suscriptorsearch',
        },
        params: {
          zalias: 'interesados',
          target: 'backend',
          entity: 'cnt',
          value: 'id',
          filters: '{"delete_flag":0,"type":{"$distinct":2308},"location.id":{"$not":["D67C447EFFF301FB9ABA001DD8C32A59","EC693C1C83B101F69C83001CC4BEAABC"]}}',
          match: 'middle_name,last_name,first_name,zdni,userid',
          fields: 'id,first_name,middle_name,last_name,zdni,location.id,position.name,location.name,uspContact.gerhonteloc.id,uspContact.gerhonteloc.zonabasica,uspContact.gerhonteloc.ztipo_loc,gerhonteloc.site_id,zfecha_ini_contrato,zfecha_fin_contrato,ztelefono_preferente,uspContact.sgiCategoria.zcodigo,location.state,location.city',
          lookandfeel: '#item.middle_name::[$1 ]#item.last_name::[$1 ]#item.first_name::[$1 ]#item.location.name::[($1) ]',
          lookandfeelType: 'cnt',
          minlength: '8',
          extraFilter: '[{"text":"Nombre", "value": "middle_name"},{"text":"Apellido 1", "value": "last_name"},{"text":"Apellido 2", "value": "first_name"}, {"text":"Localización", "value": "location.name"}, {"text":"DNI", "value": "zdni", "display": false}, {"text":"Email", "value": "email_address"}]',
          timeSearch: '1500',
          placeholder: 'Puedes realizar una búsqueda más completa haciendo click en el icono del embudo',
          nodatamessage: 'No hay datos disponible. Puedes buscar por nombre y apellidos o DNI',
          isOrdenLocation: 'true',
        },
        specials_values:
        {
          type: 'relation',
        },
        type: {
          name: 'search',
          ZCODE: 'search',
        },
      },
    };
  },
  computed: {
    title: () => INTERESADOS.key,
    icon: () => INTERESADOS.icon,
  },
  methods: {
    async searchInteresados() {
      const { id, userid } = this.$store.getters['session/user'];
      const { referenceNumber } = this.ticket;
      this.loadingGetInteresados = true;

      try {
        const response = await this.suscriptorsClient.getListSuscriptorsSolicitud({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores`,
          },
          id: referenceNumber,
        });

        if (response?.collection_suscriptors?.suscriptors?.length > 0) {
          this.interesados = response.collection_suscriptors.suscriptors
            .filter((item) => item.flujo.id === this.codigoInteresado)
            .map((item) => ({
              name: item.nombre,
              id: item.uuid,
              codigoFlujo: item.flujo.id,
            }));
        }
        this.loadingGetInteresados = false;
      } catch (error) {
        this.loadingGetInteresados = false;
        console.log(error);
      }
    },
    handleContactSuscriptor(data) {
      const { item, value } = data;
      if (item && value && this.interesados.length < this.elementMax) {
        const isUserSelected = this.interesados.find((objeto) => objeto.id === value);
        if (isUserSelected) return;

        const interesado = {
          name: `${ item.middle_name || '' } ${ item.last_name || '' } ${ item.first_name || '' }`,
          id: value,
          dni: item.zdni,
        };
        this.interesados.push(interesado);
        this.interesadosNew.push(interesado);
        // TODO
        const closeButton = document.querySelector('.v-icon--link.mdi.mdi-close');
        if (closeButton) {
          closeButton.click();
        }
      }
    },
    async deleteSuscripcion(data) {
      const { id, name } = data;
      const indexToDeleteNewInteresado = this.interesadosNew.findIndex((interesado) => interesado.id === id); // eslint-disable-line 
      if (indexToDeleteNewInteresado !== -1) {
        this.interesadosNew.splice(indexToDeleteNewInteresado, 1);
      } else {
        this.interesadosDelete.push({ id, name });
      }

      for (let i = 0; i < this.interesados.length; i += 1) {
        if (this.interesados[i].id === id) {
          this.interesados.splice(i, 1);
          break;
        }
      }
    },

    async send() {
      this.submitting = true;

      if (this.interesadosDelete.length > 0 || this.interesadosNew.length > 0) {
        const messageId = await this.createNotificationMessage();

        if (this.interesadosDelete.length > 0) {
          await this.processDeleteInteresados();
        }

        if (this.interesadosNew.length > 0) {
          const interesadoId = this.interesadosNew.map((interesado) => interesado.id);
          await this.createInteresados(interesadoId.join(';'));
        }

        this.updateNotificationMessage(messageId);
        this.resetFormState();
      }
    },
    async createNotificationMessage() {
      return this.$store.dispatch('messages/createNotificationMessage', {
        icon: 'progress-circular',
        title: this.$t('ticketActions.messages.creating'),
      });
    },
    async processDeleteInteresados() {
      const deletePromises = this.interesadosDelete
        .map((interesado) => this.deleteInteresados({ uuid: interesado.id }));

      const responseAllDelete = await Promise.all(deletePromises);

      responseAllDelete.forEach((interesado) => {
        if (interesado.status !== 200) {
          this.handleDeleteError(interesado);
        }
      });
    },
    handleDeleteError(interesado) {
      const uuidUser = interesado.config.params.data.uuid;
      const indexToDeleteInteresado = this.interesadosDelete.indexOf(uuidUser);
      this.interesadosDelete.splice(indexToDeleteInteresado, 1);
      this.isErrorDelete = true;
    },

    updateNotificationMessage(messageId) {
      const messageType = this.isErrorDelete || this.isErrorCreate ? 'error' : 'success';
      const messageTitle = this.$t(`ticketActions.messages.${messageType}`);
      const icon = messageType === 'error' ? 'mdi-close-circle' : 'mdi-check-circle';

      this.$store.dispatch('messages/updateMessage', {
        id: messageId,
        type: messageType,
        icon,
        title: messageTitle,
        timeout: this.$getConst('notifications.timeout'),
      });
    },
    resetFormState() {
      this.submitting = false;
      this.isErrorDelete = false;
      this.isErrorCreate = false;
      this.$emit('refresh:detail');
      this.$emit('input');
    },
    async createInteresados(interesadosList) {
      const { referenceNumber } = this.ticket;
      const { id, userid } = this.$store.getters['session/user'];

      const idTagApp = this.$getConst('tagActivity.interested.idTagApp');
      const idTagWeb = this.$getConst('tagActivity.interested.idTagWeb');
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      const tagActivity = isMobile ? idTagApp : idTagWeb;

      let descriptionActivity = 'Interesados añadidos: ';
      let zvirtualActivity = '';

      this.interesadosNew.forEach((interesado) => {
        descriptionActivity += `${interesado.name}, `;
        zvirtualActivity += `${interesado.id}, `;
      });

      descriptionActivity = descriptionActivity.slice(0, -2);
      zvirtualActivity = zvirtualActivity.slice(0, -2);
      try {
        const response = await this.suscriptorsClient.postSuscriptors({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${referenceNumber}/suscriptores`,
          },
          id: referenceNumber,
          suscriptorAll: interesadosList,
          descriptionActivity,
          zvirtualActivity,
          tagActivity,
          ticketID: this.ticket.id,
          flujo: {
            id: this.codigoInteresado,
          },
        });

        if (response.status !== 200) {
          await this.handleCreateInteresadosError(response);
        } else {
          this.isErrorCreate = false;
        }
      } catch (error) {
        this.isErrorCreate = true;
      }
    },
    async handleCreateInteresadosError(response) {
      const errorResponse = JSON.parse(response.data.message.split(' - ')[1]);
      const errDescription = errorResponse.descripcion;

      if (errDescription === '000078' || errDescription === '000079') {
        const uuidsList = errorResponse.errores[0].info.uuidsErrorCodigoFlujo;
        const uuidsTotal = uuidsList.join(';');
        const dataSend = { uuid: uuidsTotal };

        try {
          await this.deleteInteresados(dataSend);
          await this.createInteresados(uuidsTotal);
          this.isErrorCreate = false;
        } catch (error) {
          this.isErrorCreate = true;
        }
      }
    },
    async deleteInteresados(data) {
      const { referenceNumber } = this.ticket;
      const { uuid } = data;
      const { userid } = this.$store.getters['session/user'];

      const idTagApp = this.$getConst('tagActivity.interested.idTagApp');
      const idTagWeb = this.$getConst('tagActivity.interested.idTagWeb');
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      const tagActivity = isMobile ? idTagApp : idTagWeb;

      let descriptionActivity = 'Interesados eliminados: ';
      let zvirtualActivity = '';

      this.interesadosDelete.forEach((interesado) => {
        descriptionActivity += `${interesado.name}, `;
        zvirtualActivity += `${interesado.id}, `;
      });

      descriptionActivity = descriptionActivity.slice(0, -2);
      zvirtualActivity = zvirtualActivity.slice(0, -2);

      try {
        return await this.suscriptorsClient.deleteSuscriptors({
          apiCges: {
            delegado: userid,
            endpoint: `cges/solicitudes/${referenceNumber}/suscriptores/${ uuid }`,
          },
          id: referenceNumber,
          descriptionActivity,
          zvirtualActivity,
          uuid: data.uuid,
          tagActivity,
          ticketID: this.ticket.id,
        });
      } catch (error) {
        return error;
      }
    },
  },
  async created() {
    this.suscriptorsClient = this.$api.getClient('suscriptors');
    this.ticketClient = this.$api.getClient('ticket');

    this.searchInteresados();

    this.$root.$on('contactSuscriptor', (data) => {
      this.handleContactSuscriptor(data);
    });
  },
};
</script>

<style>
.m-1 {
  margin: 1rem 0;
}
.text__subtitle {
  font-size: .9rem;
  margin-bottom: 1rem;
}
.text__interesado__help {
  font-size: 10.4px !important;
  margin-top: 0.3rem;
  margin-bottom: 0 !important;
}
.text__interesado__error {
  color: #b64351 !important;
  margin-top: 0.5rem;
}
</style>
